import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import VendorRegister from './pages/VendorRegister';
import SuperAdminLogin from './pages/SuperAdminLogin';
import TeamManagement from './pages/SuperAdmin/TeamManagement';
import RestaurantVisits from './pages/SuperAdmin/RestaurantVisits';
import JobManagement from './pages/SuperAdmin/JobManagement';
import SuperAdminDashboard from './pages/Dashboard/SuperAdminDashboard';
import VendorDashboard from './pages/Dashboard/VendorDashboard';
import VendorOwnerDashboard from './pages/VendorOwner/VendorOwnerDashboard';
import CaptainDashboard from './pages/Dashboard/CaptainDashboard';
import CaptainLogin from './pages/Captain/CaptainLogin';
import CaptainDashboardNew from './pages/Captain/CaptainDashboard';

import VendorList from './pages/Vendors/VendorList';
import PendingVendors from './pages/Vendors/PendingVendors';

import RestaurantMenu from './pages/VendorOwner/RestaurantMenu';
import RestaurantSales from './pages/VendorOwner/RestaurantSales';
import RestaurantCaptains from './pages/VendorOwner/RestaurantCaptains';
import RestaurantsList from './pages/VendorOwner/RestaurantsList';
import ConsolidatedSales from './pages/VendorOwner/ConsolidatedSales';
import Analytics from './pages/VendorOwner/Analytics';
import AllOrders from './pages/VendorOwner/AllOrders';
import VendorOwnerSettings from './pages/VendorOwner/Settings';
import VendorOwnerMenuManagement from './pages/VendorOwner/MenuManagement';
import SimpleVendorPermissions from './pages/VendorOwner/SimpleVendorPermissions';
import VendorOwnerReports from './pages/VendorOwner/VendorOwnerReports';
import BillUpdateApprovals from './pages/VendorOwner/BillUpdateApprovals';
import BillUpdateRequests from './pages/Vendor/BillUpdateRequests';

import EnhancedDashboard from './pages/SuperAdmin/EnhancedDashboard';
import VendorManagement from './pages/SuperAdmin/VendorManagement';
import VendorOwnerManagement from './pages/SuperAdmin/VendorOwnerManagement';
import AppUserManagement from './pages/SuperAdmin/AppUserManagement';
import RoomManagement from './pages/SuperAdmin/RoomManagement';
import VendorRoomManagement from './pages/RoomManagement/RoomManagement';
import OrderMonitoring from './pages/SuperAdmin/OrderMonitoring';
import BannerManagement from './pages/SuperAdmin/BannerManagement';
import SalesAnalytics from './pages/SuperAdmin/SalesAnalytics';
import SystemSettings from './pages/SuperAdmin/SystemSettings';
import SubscriptionPlans from './pages/SuperAdmin/SubscriptionPlans';
import PlanRequests from './pages/SuperAdmin/PlanRequests';
import DeliverySettingRequests from './pages/SuperAdmin/DeliverySettingRequests';
import SuperAdminNotifications from './pages/SuperAdmin/SuperAdminNotifications';
import SuperAdminProfile from './pages/SuperAdmin/SuperAdminProfile';

import VendorDashboardMain from './pages/Vendor/VendorDashboard';
import MenuManagement from './pages/Vendor/MenuManagement';
import OrdersManagement from './pages/Vendor/OrdersManagement';
import OpenTables from './pages/Vendor/OpenTables';
import QRCodeManagement from './pages/Vendor/QRCodeManagement';
import CaptainManagement from './pages/Vendor/CaptainManagement';
import NotificationManagement from './pages/Vendor/NotificationManagement';
import CouponManagement from './pages/Vendor/CouponManagement';
import ExpenseManagement from './pages/Vendor/ExpenseManagement';
import InventoryManagement from './pages/Vendor/InventoryManagement';
import StockManagement from './pages/Vendor/StockManagement';
import VendorReports from './pages/Vendor/VendorReports';
import VendorSettings from './pages/Vendor/VendorSettings';
import VendorProfile from './pages/Vendor/VendorProfile';
import VendorSubscription from './pages/Vendor/VendorSubscription';
import SubscriptionHistory from './pages/Vendor/SubscriptionHistory';
import Billing from './pages/Vendor/Billing';
import BookingManagement from './pages/BookingManagement/BookingManagement';
import BillPrint from './pages/BookingManagement/BillPrint';
import BanquetManagement from './pages/Vendor/BanquetManagement';
import SuperAdminBanquetManagement from './pages/SuperAdmin/SuperAdminBanquetManagement';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/superadmin/login" element={<SuperAdminLogin />} />
          <Route path="/register" element={<VendorRegister />} />
          <Route path="/captain/login" element={<CaptainLogin />} />
          <Route path="/captain/dashboard" element={<CaptainDashboardNew />} />
          
          <Route path="/dashboard" element={
            <PrivateRoute>
              <Layout>
                <DashboardRouter />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/vendors" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <VendorList />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/vendors/pending" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <PendingVendors />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor-owner/dashboard" element={
            <PrivateRoute allowedRoles={['vendorOwner']}>
              <Layout>
                <VendorOwnerDashboard />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor-owner/restaurants" element={
            <PrivateRoute allowedRoles={['vendorOwner']}>
              <Layout>
                <RestaurantsList />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor-owner/menu-management" element={
            <PrivateRoute allowedRoles={['vendorOwner']}>
              <Layout>
                <VendorOwnerMenuManagement />
              </Layout>
            </PrivateRoute>
          } />
          <Route path="/vendor-owner/vendor-permissions" element={
            <PrivateRoute allowedRoles={['vendorOwner']}>
              <Layout>
                <SimpleVendorPermissions />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor-owner/sales" element={
            <PrivateRoute allowedRoles={['vendorOwner']}>
              <Layout>
                <ConsolidatedSales />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor-owner/analytics" element={
            <PrivateRoute allowedRoles={['vendorOwner']}>
              <Layout>
                <Analytics />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor-owner/orders" element={
            <PrivateRoute allowedRoles={['vendorOwner']}>
              <Layout>
                <AllOrders />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor-owner/reports" element={
            <PrivateRoute allowedRoles={['vendorOwner']}>
              <Layout>
                <VendorOwnerReports />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor-owner/settings" element={
            <PrivateRoute allowedRoles={['vendorOwner']}>
              <Layout>
                <VendorOwnerSettings />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor-owner/bill-update-approvals" element={
            <PrivateRoute allowedRoles={['vendorOwner']}>
              <Layout>
                <BillUpdateApprovals />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor-owner/restaurant/:restaurantId/menu" element={
            <PrivateRoute allowedRoles={['vendorOwner']}>
              <Layout>
                <RestaurantMenu />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor-owner/restaurant/:restaurantId/sales" element={
            <PrivateRoute allowedRoles={['vendorOwner']}>
              <Layout>
                <RestaurantSales />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor-owner/restaurant/:restaurantId/captains" element={
            <PrivateRoute allowedRoles={['vendorOwner']}>
              <Layout>
                <RestaurantCaptains />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/dashboard" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <EnhancedDashboard />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/vendor-management" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <VendorManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/vendor-owners" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <VendorOwnerManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/app-users" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <AppUserManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/room-management" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <RoomManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/orders" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <OrderMonitoring />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/banners" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <BannerManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/analytics" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <SalesAnalytics />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/settings" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <SystemSettings />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/subscription-plans" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <SubscriptionPlans />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/plan-requests" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <PlanRequests />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/delivery-requests" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <DeliverySettingRequests />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/notifications" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <SuperAdminNotifications />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/profile" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <SuperAdminProfile />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/sales-officers" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <TeamManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/restaurant-visits" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <RestaurantVisits />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/jobs" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <JobManagement />
              </Layout>
            </PrivateRoute>
          } />

          {/* Vendor Routes */}
          <Route path="/vendor/dashboard" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <VendorDashboardMain />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/menu" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <MenuManagement />
              </Layout>
            </PrivateRoute>
          } />


          <Route path="/vendor/orders" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <OrdersManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/bill-update-requests" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <BillUpdateRequests />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/open-tables" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <OpenTables />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/qr-codes" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <QRCodeManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/captains" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <CaptainManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/notification" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <NotificationManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/coupons" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <CouponManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/expenses" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <ExpenseManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/inventory" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <InventoryManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/stock" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <StockManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/reports" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <VendorReports />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/profile" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <VendorProfile />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/subscription" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <VendorSubscription />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/subscription-history" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <SubscriptionHistory />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/billing" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <Billing />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/room-management" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <VendorRoomManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/booking-management" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <BookingManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/bill/:checkinId" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <BillPrint />
            </PrivateRoute>
          } />

          <Route path="/vendor/banquet" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <BanquetManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/superadmin/banquet" element={
            <PrivateRoute allowedRoles={['superadmin']}>
              <Layout>
                <SuperAdminBanquetManagement />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/vendor/settings" element={
            <PrivateRoute allowedRoles={['vendor']}>
              <Layout>
                <VendorSettings />
              </Layout>
            </PrivateRoute>
          } />

          <Route path="/" element={<Navigate to="/login" replace />} />
          
          <Route path="*" element={
            <div style={{ padding: '40px', textAlign: 'center' }}>
              <h1>404 - Page Not Found</h1>
            </div>
          } />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

const DashboardRouter = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  switch (user.role) {
    case 'superadmin':
      return <SuperAdminDashboard />;
    case 'vendor':
      return <Navigate to="/vendor/billing" replace />;
    case 'vendorOwner':
      return <VendorOwnerDashboard />;
    case 'captain':
      return <CaptainDashboardNew />;
    default:
      return <Navigate to="/login" replace />;
  }
};

export default App;
